import React, { Component } from 'react';
import moment from 'moment';
import Project from './project.jsx'
import { calculateDuration } from '../api/timeListProcess';
import { toast } from 'react-toastify';
import Recorddata from './recordData.jsx'

class Record extends Component {

  constructor(props){
    super(props)
    this.date = '';
    this.recordList = [];
    this.handleChange = this.handleChange.bind(this)
    this.handleSubmit = this.handleSubmit.bind(this)
    this.state = Object.assign( {open:false}, this.props.time )
    this.deleteNotifOpened = false;
  }

  handleSubmit(e){
    e.preventDefault()
    if( this.state.name !== this.props.time.name ){
      this.props.updateRecord(this.state)
    }
  }

  handleChange(e){
    this.setState({name:e.target.value})
  }

  delete = ()=>{
    if(!this.deleteNotifOpened){
      toast.info((
        <div className="delete-notif">
          <p>
          آیا برای حذف زمان
          { ' ' + ( this.state.name ? '"'+this.state.name.trunc(10)+'"' : '(بدون عنوان)' ) + ' ' }
          مطمئن هستید؟
          </p>
          <button className='btn btn-sm btn-success' onClick={this.props.deleteRecord.bind(null, this.state.id)}>بله</button>
          <button className='btn btn-sm btn-danger'>خیر</button>
        </div>
        ), {
        onOpen: () => this.deleteNotifOpened = true,
        onClose: () => this.deleteNotifOpened = false,
        closeButton: false,
        rtl : true
      });
    }
    
  }

  toggle = ()=>{
    this.setState({open : !this.state.open})
  }

  render() {
    this.duration = calculateDuration(this.props.time)
    this.start = moment(this.props.time.start).locale('en').format('H:mm')
    this.end = moment(this.props.time.end).locale('en').format('H:mm')
    return (
      <div>
        <div className="record-card">
          <div>
            <form onSubmit={this.handleSubmit}>
              <input type="text" placeholder="(بدون عنوان)" value={this.state.name || ''} onChange={this.handleChange} onBlur={this.handleSubmit} className="record-title-input"/>
            </form>
          </div>
          <div>
            <Project active={false} selected={this.props.time}></Project>
          </div>
          <div className="record-time">
            <div className="pull-right" onClick={this.toggle.bind(this)}>
              <i>
                { this.start } - { this.end }
              </i>
            </div>   
            <div className="pull-left">
              <b>
                {this.duration}
              </b>
              <span className="record-control">
                <i className="glyphicon glyphicon-play" onClick={this.props.startSameRecord.bind(null, this.state)} ></i>
                <i className="glyphicon glyphicon-trash" onClick={this.delete}></i>
              </span>
            </div>
            
          </div>
        </div>
        <div>
          <Recorddata time={this.props.time} updateRecord={this.props.updateRecord} open={this.state.open} toggle={this.toggle.bind(this)} />
        </div>
      </div>
    );
  }
}

Record.defaultProps = {
  time : { project:{} },
  updateRecord: ()=>{},
  deleteRecord: ()=>{},
  startSameRecord: ()=>{}
}
export default Record;
